import React from 'react';
import PayrollActiveTable from './SubComponents/PayrollActiveTable';
import PayrollHistoryTable from './SubComponents/PayrollHistoryTable';
import { ATTENDANCE_SUBVIEW_MODEL } from '../Model/Model';
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const PayrollTab = ({
    subView,
    changeSubView,
    option,
    setBodyForExport,
    searchElement,
    setSearchElement,
    setSimpleSearch,
    search,
    setSearch,
    modified,
    setModified,
    activeStep,
    registerAction,
    setExportReady,
}) => (
    subView === ATTENDANCE_SUBVIEW_MODEL.PAYROLL.ACTIVE
        ? <PayrollActiveTable
            subView={subView}
            changeSubView={changeSubView}
            option={option}
            setBodyForExport={setBodyForExport}
            searchElement={searchElement}
            setSearchElement={setSearchElement}
            setSimpleSearch={setSimpleSearch}
            search={search}
            setSearch={setSearch}
            modified={modified}
            setModified={setModified}
            activeStep={activeStep}
            registerAction={registerAction}
        />
        : <PayrollHistoryTable
            subView={subView}
            changeSubView={changeSubView}
            option={option}
            setBodyForExport={setBodyForExport}
            searchElement={searchElement}
            setSearchElement={setSearchElement}
            setSimpleSearch={setSimpleSearch}
            search={search}
            setSearch={setSearch}
            modified={modified}
            setModified={setModified}
            activeStep={activeStep}
            setExportReady={setExportReady}
        />
);

export default PayrollTab;
